import { db } from '../db/db';
import { useStore } from '../store/useStore';

export const CompanyDeleteConfirmView = ({ handleItemSelect, companyId }: any) => {
  const setActiveCompany = useStore((state) => state.setActiveCompany);
  const activeCompany = useStore((state) => state.activeCompany);

  const handleDelete = async () => {
    await db.transaction('rw', [db.companies, db.groups, db.ledgers, db.vouchers, db.voucherEntries, db.stockGroups, db.stockItems, db.units, db.locations, db.inventoryEntries, db.stockCategories], async () => {
      // Delete all data associated with this company
      await db.groups.where('companyId').equals(companyId).delete();
      await db.ledgers.where('companyId').equals(companyId).delete();
      // Let's do it properly
      const vouchers = await db.vouchers.where('companyId').equals(companyId).toArray();
      const vIds = vouchers.map(v => v.id!);
      if (vIds.length > 0) {
        await db.voucherEntries.where('voucherId').anyOf(vIds).delete();
        await db.inventoryEntries.where('voucherId').anyOf(vIds).delete();
      }
      await db.vouchers.where('companyId').equals(companyId).delete();
      
      await db.stockItems.where('companyId').equals(companyId).delete();
      await db.stockGroups.where('companyId').equals(companyId).delete();
      await db.stockCategories.where('companyId').equals(companyId).delete();
      await db.units.where('companyId').equals(companyId).delete();
      await db.locations.where('companyId').equals(companyId).delete();
      
      await db.companies.delete(companyId);
    });

    if (activeCompany?.id === companyId) {
      const nextCompany = await db.companies.toCollection().first();
      if (nextCompany) {
        await db.companies.where('isActive').equals(1).modify({ isActive: 0 });
        await db.companies.update(nextCompany.id!, { isActive: 1 });
        setActiveCompany({ ...nextCompany, isActive: 1 });
      } else {
        setActiveCompany(null);
      }
    }

    handleItemSelect({ name: 'Quit' });
  };

  return (
    <div className="flex flex-col w-full h-full bg-[#f8faf7] z-50 absolute inset-0 font-sans text-[13px] text-black border-2 border-[#1e8585]">
      <div className="bg-[#1e8585] text-white flex justify-between px-2 py-[2px] font-bold shadow-sm">
        <span>Delete Company</span>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center p-8">
        <div className="bg-white border-2 border-red-600 p-8 shadow-xl max-w-md text-center">
          <h2 className="text-xl font-bold text-red-600 mb-4">Confirm Deletion</h2>
          <p className="mb-6">Are you sure you want to delete this company and all its associated data? This action cannot be undone.</p>
          <div className="flex gap-4 justify-center">
            <button 
              onClick={handleDelete}
              className="bg-red-600 text-white px-8 py-2 font-bold hover:bg-red-700 shadow-md"
            >
              Yes, Delete
            </button>
            <button 
              onClick={() => handleItemSelect({ name: 'Quit' })}
              className="bg-gray-200 px-8 py-2 font-bold hover:bg-gray-300 shadow-md"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
